// extracted by mini-css-extract-plugin
export default {"loader":"PageLoader_loader__siV4R","spinner":"PageLoader_spinner__0fCJp","spin":"PageLoader_spin__EeGyF","srOnly":"PageLoader_srOnly__3ByOJ"};